import React from "react";
import clsx from "clsx";
import { Row, Col } from "react-bootstrap";

import { ReactComponent as AlertIcon } from "static/images/alert-round.svg";
import styles from "../filter.module.scss";

const AgeErrorMessage = () => {
	return (
		<Row>
			<Col
				sm={{ offset: 4, span: 8 }}
				className={clsx("errorMessage mt-2", styles.errorContainer)}
			>
				<AlertIcon width="27" />
				<span>
					Age Maximum must be a higher value than the Age Minimum
				</span>
			</Col>
		</Row>
	);
};

export default AgeErrorMessage;
